import { AxiosResponse } from 'axios';
import axios from 'axios';
import { createApiClient } from './client';
import { Asset, AssetSpace, SpaceRelation } from '../interfaces';
import { Point } from 'geojson';

const asset = () => createApiClient('/asset');

// 按项目查询资源列表
export async function getAssetsByProjectId(
  projectId: number,
): Promise<AxiosResponse<Asset[]>> {
  return asset().get('/', { params: { projectId } });
}

// 按空间查询资源（含空间关系与偏移）
export async function getAssetsBySpaceId(spaceId: number) {
  return asset().get<
    {
      assetSpace: AssetSpace;
      spaceRelation: SpaceRelation;
      offset: Point;
    }[]
  >('/getAssetsBySpaceId', { params: { spaceId } });
}

// 获取资源的原始文件下载 URL（已内置 token）
export async function getOriginFileUrl(assetId: number): Promise<string> {
  const res = await asset().get(`/${assetId}/originFile`);
  return res.data.url;
}

// 获取资源的原始文件 ArrayBuffer（如 PDF）
export async function getOriginFileArrayBuffer(assetId: number) {
  const url = await getOriginFileUrl(assetId);
  // 不能加 Authorization 头，URL 已内置 token
  return axios.get(url, { responseType: 'arraybuffer' });
}

// 提交识别原始资源
export async function processOriginAsset(assetId: number) {
  return asset().put(`/${assetId}/processOrigin`);
}

// 初始化三步上传
export async function initiateUpload(projectId: number) {
  return asset().post('/initiateUpload', { projectId });
}

// 确认上传完成
export async function confirmUpload(projectId: number, confirmKey: string) {
  return asset().post('/confirmUpload', { projectId, confirmKey });
}
